var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var ReadMoreContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n"], ["\n    font-family: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.inter;
});
export var ToggleButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: none;\n    border: none;\n    cursor: pointer;\n    margin-left: ", ";\n    transition: transform 0.2s ease;\n    &:hover {\n        transform: scale(1.05);\n    }\n"], ["\n    background: none;\n    border: none;\n    cursor: pointer;\n    margin-left: ", ";\n    transition: transform 0.2s ease;\n    &:hover {\n        transform: scale(1.05);\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxSmall;
});
var templateObject_1, templateObject_2;
